import React from "react";

const DButton = ({
    bgColor = "primary",
    borderColor = "primary",
    varient = "fill",
    type = "button",
    className,
    children,
    ...rest
}) => {
    const bgColorType = {
        primary: "bg-primary-color-500 hover:bg-primary-color-400",
        secondry: "bg-secondry-color-500 hover:bg-secondry-color-400",
        light: "bg-slate-300 hover:bg-slate-400",
        success: "bg-green-500 hover:bg-green-400",
        danger: "bg-red-500 hover:bg-red-400",
    };
    const borderColorType = {
        primary: "border-primary-color-500",
        secondry: "border-secondry-color-500",
        light: "border-slate-300 ",
        success: "border-green-500",
        danger: "border-red-500",
    };
    const varientType = {
        fill: `${bgColorType[bgColor]} `,
        outlined: `border ${borderColorType[borderColor]} `,
        transparent: "bg-transparent",
    };
    return (
        <button
            {...rest}
            type={type}
            className={`mx-1 p-2 transition-all outlined-none rounded-lg ${varientType[varient]}  ${className}`}
        >
            {children}
        </button>
    );
};

export default DButton;
